/* ========================================================================
   On document ready do stuff
 ========================================================================== */

util.onDocumentReady(function () {
  // Set frontend version
  util.frontEndVersion = document.getElementById('body').dataset.version;

  // Set debug mode
  util.debugMode = document.getElementById('body').dataset.debugMode === 'true';

  // Enable transitions
  document.documentElement.classList.remove('preloadTransitions');

  // Pristine config
  app.pristineConfig = {
    // class of the parent element where the error/success class is added
    classTo: 'form__group',
    errorClass: 'has-error',
    successClass: 'has-success',
    // class of the parent element where error text element is appended
    errorTextParent: 'form__group',
    // type of element to create for the error text
    errorTextTag: 'div',
    // class of the error text element
    errorTextClass: 'form__validation',
    locale: 'nl',
  };

  // Enable SVG in IE11
  // svg4everybody();

  app.general.initAppHeight();
  // app.general.initTouch();
  app.navigation.initMenu();
  // app.navigation.initSearchBox();
  // app.general.initEmailLinks();
  // app.general.initLax();
  app.cookiePopup.init();
  // app.dataLayer.init();

  const min = util.debugMode === false ? '.min' : '';

  // Dynamically load scripts: https://github.com/malko/l.js
  if (document.querySelectorAll('[data-generic-form]').length > 0) {
    ljs.load(
      // util.getVersionedUrl('/scripts/dist/loadingOverlay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.generic' + min + '.js'),
      () => {
        app.genericForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-registration-form]').length > 0) {
    ljs.load(
      // util.getVersionedUrl('/scripts/dist/loadingOverlay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.registration' + min + '.js'),
      () => {
        app.registrationForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-upload-file-form]').length > 0) {
    ljs.load(
      // util.getVersionedUrl('/scripts/dist/loadingOverlay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/dialog' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/uploadField' + min + '.js'), // uploadField depends on dialog and toast
      util.getVersionedUrl('/scripts/dist/forms.uploadFiles' + min + '.js'),
      () => {
        app.uploadFilesForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-incident-form]').length > 0) {
    ljs.load(
      'https://cdn.jsdelivr.net/npm/flatpickr@4.6.13/dist/flatpickr.min.css',
      'https://cdn.jsdelivr.net/npm/flatpickr@4.6.13/dist/flatpickr.min.js',
      'https://cdn.jsdelivr.net/npm/flatpickr@4.6.13/dist/l10n/nl.js',
      util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
      // util.getVersionedUrl('/scripts/dist/loadingOverlay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.incident' + min + '.js'),
      () => {
        app.incidentForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-complaint-form]').length > 0) {
    ljs.load(
      'https://cdn.jsdelivr.net/npm/flatpickr@4.6.13/dist/flatpickr.min.css',
      'https://cdn.jsdelivr.net/npm/flatpickr@4.6.13/dist/flatpickr.min.js',
      'https://cdn.jsdelivr.net/npm/flatpickr@4.6.13/dist/l10n/nl.js',
      util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/dialog' + min + '.js'),
      // util.getVersionedUrl('/scripts/dist/toast' + min + '.js'),
      // util.getVersionedUrl('/scripts/dist/loadingOverlay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/uploadField' + min + '.js'), // uploadField depends on dialog and toast
      util.getVersionedUrl('/scripts/dist/forms.complaint' + min + '.js'),
      () => {
        app.complaintForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-association-form]').length > 0) {
    ljs.load(
      // util.getVersionedUrl('/scripts/dist/loadingOverlay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.association' + min + '.js'),
      () => {
        app.associationForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-workshop-form]').length > 0) {
    ljs.load(
      // util.getVersionedUrl('/scripts/dist/loadingOverlay' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/aspnet-validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.validation' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/forms.workshop' + min + '.js'),
      () => {
        app.workshopForm.init();
      }
    );
  }

  if (document.querySelectorAll('[data-toast-message]').length > 0) {
    // show toast messages (with delay)
    const toastMessages = document.querySelectorAll('[data-toast-message]');
    toastMessages.forEach((message, index) => {
      window.setTimeout(() => {
        Toast(message.innerHTML, message.dataset.toastType.toLowerCase(), message.dataset.toastTimeout ?? 7500);
      }, index * 1000);
    });
  }

  if (document.querySelectorAll('[data-video-lightbox]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/videoLightbox' + min + '.js'), () => {
      const videos = document.querySelectorAll('[data-video-lightbox]');
      VideoLightbox(videos);
    });
  }

  if (document.querySelectorAll('[data-faq-item]').length > 0) {
    ljs.load(util.getVersionedUrl('/scripts/dist/modules.faq' + min + '.js'), () => {
      app.faqSection.init();
    });
  }

  if (document.querySelectorAll('[data-carousel]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/embla' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.carousel' + min + '.js'),
      () => {
        app.carousel.init();
      }
    );
  }

  if (document.querySelectorAll('[data-lax]').length > 0) {
    ljs.load(
      util.getVersionedUrl('/scripts/dist/lax' + min + '.js'),
      util.getVersionedUrl('/scripts/dist/modules.lax' + min + '.js'),
      () => {
        app.lax.init();
      }
    );
  }
});
